var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPatientDeleteButton = function SvgPatientDeleteButton(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4A657B",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.4,
    d: "M10.88 4.889l.095 7.986A2.1 2.1 0 0 1 8.875 15h-5.75a2.1 2.1 0 0 1-2.1-2.125l.096-7.986"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.7,
    d: "M6.333 6.333v6.5"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.4,
    d: "M1 2.722h10M3.667 1H8.5"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.7,
    d: "M8.667 6.333v6.5M3.667 6.333v6.5"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPatientDeleteButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/patient-delete-button.5b4c1c14d4c3ba35fbd4baf53f77f4f7.svg";